// src/PolicyLinks.js
import React from 'react';
import { Link } from 'react-router-dom';
import './PolicyLinks.css';

const PolicyLinks = () => {
  return (
    <div className="policy-footer">
      <div className="policy-links">
        <Link to="/cookie-policy">Cookie Policy</Link>
        <span className="separator">|</span>
        <Link to="/terms-of-use">Podmienky používania</Link>
        <span className="separator">|</span>
        <Link to="/privacy-policy">Zásady ochrany osobných údajov</Link>
      </div>

      <div className="martin-credit">
        <div id="martin-sulak-logo-widget">
          <a
            href="https://martinsulak.dev"
            className="martin-sulak-logo-link"
            aria-label="Prejsť na martinsulak.dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="martin-sulak-logo-avatar" aria-hidden="true">M</div>
          </a>
        </div>

        <div className="martin-credit-text">
          <span>Web vytvoril</span>
          <a href="https://martinsulak.dev" target="_blank" rel="noopener noreferrer">Martin Sulak</a>
        </div>
      </div>
    </div>
  );
};

export default PolicyLinks;